import React, { useEffect } from "react"
import { Box, Card, Typography } from "@mui/material"
import type { StationGeojson } from "types/stations"
import StationAvailable from "layouts/station/utils/icons/Icon_Map_Disponible.svg"
import StationPlanned from "layouts/station/utils/icons/Icon_Map_En cours de développement.svg"

interface MapLegendProps {
    geojson: StationGeojson
}

const legendCardContentStyle = {
    paddingBlock: "10px",
    paddingInline: "10px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
}

export const MapLegend = React.memo((props: MapLegendProps) => {
    const [numberAvailable, setNumberAvailable] = React.useState(0)

    useEffect(() => {
        if (props.geojson) {
            const availableStations = props.geojson.features.filter(
                (station) => station.properties.status === "available"
            )
            setNumberAvailable(availableStations.length)
        }
    }, [props.geojson])
    return (
        <Box>
            <Box
                sx={{
                    position: "absolute",
                    bottom: "11%",
                    left: "2%",
                    marginBottom: "8px",
                }}
            >
                <Card
                    data-testid="station_available"
                    sx={{ borderRadius: "10px", ...legendCardContentStyle }}
                >
                    <img src={StationAvailable} alt="AvailableIcon" />
                    <Typography
                        data-testid="station_available_content"
                        variant="titleSmall"
                        sx={{ paddingLeft: "15px" }}
                    >
                        {numberAvailable} Stations disponibles
                    </Typography>
                </Card>
            </Box>
            <Box sx={{ position: "absolute", bottom: "4%", left: "2%" }}>
                <Card
                    data-testid="station_planned"
                    sx={{ borderRadius: "10px", ...legendCardContentStyle }}
                >
                    <img src={StationPlanned} alt="PlannedIcon" />
                    <Typography
                        data-testid="station_planned_content"
                        variant="titleSmall"
                        sx={{ display: "inline-block", paddingLeft: "15px" }}
                    >
                        Stations en cours de développement
                    </Typography>
                </Card>
            </Box>
        </Box>
    )
})

export default MapLegend
